import { track } from '@betterment/js-runtime';
import * as TestTrack from '@betterment-oss/test-track';

export const testTrackPromise = TestTrack.initialize({
  analytics: {
    trackAssignment(_visitorId, assignment, callback) {
      track(
        'SplitAssigned',
        {
          splitName: assignment.splitName,
          splitVariant: assignment.variant ?? '',
          splitContext: assignment.context ?? undefined,
        },
        () => callback(true)
      );
    },
    alias: () => {},
    identify: () => {},
  },

  onVisitorLoaded(visitor) {
    window.analytics?.identify(visitor.getId());
  },
});
